module.exports = __webpack_public_path__ + "assets/img/Future_cover.a1004944-ps.jpg";